import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
import { ConsignmentStatusEnum } from "../routes/consignments/api/Representation";
class ConsignmentStatusType extends Enumify() {
    description;
    colour;
    static UNASSIGNED = new ConsignmentStatusType("UNASSIGNED", "#f24b03");
    static SCHEDULED = new ConsignmentStatusType("SCHEDULED", "#06e6f5");
    static ON_ROUTE = new ConsignmentStatusType("ON ROUTE", "#0802f5");
    static PICKED_UP = new ConsignmentStatusType("PICKED UP", "#bab8f5");
    static AT_DC = new ConsignmentStatusType("AT DC", "#f50de3");
    static ASSIGNED = new ConsignmentStatusType("ASSIGNED", "#2db7f5");
    static STARTED = new ConsignmentStatusType("STARTED", "#108ee9");
    static COMPLETED = new ConsignmentStatusType("COMPLETED", "#87d068");
    static CANCELLED = new ConsignmentStatusType("CANCELLED", "#aaa");
    static _ = ConsignmentStatusType._closeEnum();
    static ARRIVED_COLOUR = "#7c5bf5";
    static ARRIVED_DESCRIPTION = "ARRIVED";
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag(descriptionOverride = null, colourOverride = null, variant = 'solid') {
        const description = descriptionOverride || this.description;
        const color = colourOverride || this.colour;
        return _jsx(Tag, { color: color, variant: variant, children: description });
    }
    static renderTagForConsignment(consignment) {
        const consignmentStatus = ConsignmentStatusType.valueOf(consignment.status);
        if (!consignmentStatus) {
            return _jsx(Tag, { color: "#ff0000", children: "UNKNOWN" });
        }
        let effectiveColour = consignmentStatus.colour;
        let effectiveDescription = consignmentStatus.description;
        if (consignmentStatus === ConsignmentStatusType.STARTED && consignment.deliveryArrivedAt) {
            effectiveColour = ConsignmentStatusType.ARRIVED_COLOUR;
            effectiveDescription = ConsignmentStatusType.ARRIVED_DESCRIPTION;
        }
        if (consignmentStatus === ConsignmentStatusType.UNASSIGNED && "marketplaceListings" in consignment && consignment.marketplaceListings && consignment.marketplaceListings.length >= 1) {
            effectiveColour = "#f2930c";
            effectiveDescription = "ON MARKET";
        }
        return consignmentStatus.renderTag(effectiveDescription, effectiveColour);
    }
    static renderTagForAssignedAction(assignedAction) {
        return ConsignmentStatusType.valueOf(assignedAction.actionStatus).renderTag(null, null);
    }
    static defaultFilters() {
        return ["UNASSIGNED", "SCHEDULED", "ON_ROUTE", "PICKED_UP", "AT_DC", "ASSIGNED", "STARTED", "COMPLETED"];
    }
    static incompleteFilters() {
        return ["UNASSIGNED", "SCHEDULED", "ON_ROUTE", "PICKED_UP", "AT_DC", "ASSIGNED", "STARTED"];
    }
    static filtersArray() {
        return ConsignmentStatusType.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
    canAddOrRemoveFromMarket() {
        switch (this) {
            case ConsignmentStatusType.UNASSIGNED:
            case ConsignmentStatusType.ASSIGNED:
                return true;
            default:
                return false;
        }
    }
    isAwaitingCompletion() {
        switch (this) {
            case ConsignmentStatusType.COMPLETED:
            case ConsignmentStatusType.CANCELLED:
                return false;
            default:
                return true;
        }
    }
}
export default ConsignmentStatusType;
